import { Reducer } from 'redux';
import { types } from './ConfirmationActions';
import { IConfirmationAction, IConfirmationState } from './ConfirmationModel';

export const confirmationReducer: Reducer<
    IConfirmationState,
    IConfirmationAction
> = (state: IConfirmationState = {}, action: IConfirmationAction) => {
    switch (action.type) {
        case types.DISPLAY_CONFIRMATION_MESSAGE: {
            return {
                ...state,
                title: action.title,
                message: action.message,
                type: action.confirmationType,
                param1: action.param1,
                param2: action.param2,
                param3: action.param3,
                param4: action.param4,
                visible: true,
            };
        }

        case types.HANDLE_CONFIRMATION_CLOSE: {
            return {
                ...state,
                title: '',
                message: '',
                type: '',
                visible: false,
                param1: '',
                param2: '',
                param3: '',
                param4: '',
            };
        }

        default:
            return state;
    }
};
